module.exports = __webpack_public_path__ + "media/jump-intro.8c6cf367.mp4";